import { render, staticRenderFns } from "./ErrosBip.vue?vue&type=template&id=64033aa2"
import script from "./ErrosBip.vue?vue&type=script&lang=js"
export * from "./ErrosBip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports